import { RubberOperationResponse, RubberTechMapResponse } from '@/shared/state/api/swagger';
import { CancelOperationFormBase } from './cancel-operation-form-base';
import { BaseCancelOperationFormProps, CancelOperationConfig } from './cancel-operation-form.types';

interface CancelRubberOperationRequest {
	closing_employee_fio: string;
	rubber_operation_id: number;
}

const useCancelRubberOperationMutation = () => {
	const cancelOperation = (params: { cancelRequest: CancelRubberOperationRequest }) => {
		return { unwrap: () => Promise.resolve({ success: true }) };
	};

	return [cancelOperation, { isLoading: false }] as const;
};

const useUpdateRubberOperations = (techMapId: number) => {
	const updateOperations = async (operations: RubberOperationResponse[]) => {
		return Promise.resolve();
	};

	return { updateOperations };
};

const rubberOperationConfig: CancelOperationConfig<
	RubberOperationResponse,
	RubberTechMapResponse,
	CancelRubberOperationRequest
> = {
	useCancelMutation: () => {
		const [cancelOperation, meta] = useCancelRubberOperationMutation();
		return [cancelOperation, meta];
	},

	useUpdateOperations: (techMapId: number) => useUpdateRubberOperations(techMapId),

	buildCancelPayload: (operation, employeeFio) => ({
		closing_employee_fio: employeeFio,
		rubber_operation_id: operation.id!,
	}),

	getOperationTitle: (operation) => String(operation.name || ''),
	getOperationStepId: (operation) => operation.step_id,
	getOperationId: (operation) => operation.id,
	getTechMapId: (techMap) => Number(techMap.id),
	getTechMapNumber: (techMap) => Number(techMap.number),

	markOperationCanceled: (operation, date) => ({
		...operation,
		date,
		is_canceled: true,
	}),

	markOperationNotCanceled: (operation, date) => ({
		...operation,
		date,
		is_canceled: false,
	}),

	getOperationCanceledStatus: (operation) => Boolean(operation.is_canceled),
};

export type RubberCancelOperationFormProps = BaseCancelOperationFormProps<
	RubberOperationResponse,
	RubberTechMapResponse
>;

export const RubberCancelOperationForm = (props: RubberCancelOperationFormProps) => {
	return <CancelOperationFormBase {...props} config={rubberOperationConfig} />;
};
